/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { enviroment } from 'src/environments/environment';

export interface ValidatorPrestamoResponse {
  formulario_id: string;
  es_valida: boolean;
  mensaje: string;
}

@Injectable({
  providedIn: 'root',
})
export class ValidatorPrestamoService {
  constructor(private httpClient: HttpClient) {}

  async validarPrestamo(formularioId: string): Promise<ValidatorPrestamoResponse> {
    const url = `${enviroment.url}validator/prestamo/${formularioId}`;
    return firstValueFrom(this.httpClient.get<ValidatorPrestamoResponse>(url));
  }
}
